import { render, staticRenderFns } from "./MusicStreaming.vue?vue&type=template&id=01bc9168&scoped=true"
import script from "./MusicStreaming.vue?vue&type=script&lang=js"
export * from "./MusicStreaming.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bc9168",
  null
  
)

export default component.exports